module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_intro-tsudoi02-6f6eb908951d29473c632cb7a3cb387d.jpg";